/**
 * /privacy — public Privacy Policy page.
 *
 * The document is a vendored, self-contained HTML file (its own inline
 * <style>, no dependency on the app shell) served as a static asset from
 * public/privacy.html. It's rendered here via LegalDocumentShell, which
 * puts it in an <iframe> so its styling stays isolated from the rest of
 * Aelita and the source file can be swapped wholesale (e.g. after
 * attorney review or a Termly regeneration) without touching any React
 * code. See LegalDocumentShell and public/legal-doc-overrides.css for how
 * the document is made to look like part of the app despite that isolation.
 */

import { createFileRoute } from '@tanstack/react-router';
import { LegalDocumentShell } from '@/components/legal/LegalDocumentShell';

export const Route = createFileRoute('/privacy')({
  component: PrivacyPage,
});

function PrivacyPage() {
  return <LegalDocumentShell src="/privacy.html" title="Privacy Policy" />;
}
